import { func, string, object } from 'prop-types'
import { Alert, Button } from '@opallabs/kuiper'
import { AnalyticsLayer } from '@opallabs/quanta'

const ConfirmationModal = ({
  entity,
  message,
  onClose,
  onConfirm,
  title,
  type,
}) => (
  <AnalyticsLayer name="Confirmation Modal">
    <Alert className={`alert-${type}`} title={title} message={message}>
      <Button
        className="cancel"
        label="Cancel"
        type="nobutton"
        onClick={onClose}
      />
      <AnalyticsLayer name={`${type} ${entity.type}`}>
        <Button
          className={type}
          color={type === 'delete' ? 'red' : 'blue'}
          label={type}
          onClick={onConfirm}
        />
      </AnalyticsLayer>
    </Alert>
  </AnalyticsLayer>
)

ConfirmationModal.propTypes = {
  entity: object,
  message: string,
  onClose: func,
  onConfirm: func,
  title: string,
  type: string,
}

export default ConfirmationModal
